module.exports = __webpack_public_path__ + "static/bruceSite2-198a077ac7a45b4abe25b13fc3dc6bda.jpg";